export default {
  empty: 'No consumption was recorded for this job.',
};
